import { put, call, debounce } from 'redux-saga/effects'

// Redux
import * as types from 'Redux/Types/DocumentStatsTypes'
import * as actions from 'Redux/Actions/DocumentStatsActions'

// Services
import * as api from 'Service/Api'

function* fetchComplianceStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchComplianceStats, payload)
    yield put(actions.fetchComplianceStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchComplianceStatsFailed(error))
  }
}

function* fetchDocumentTypeStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchDocumentTypeStats, payload)
    yield put(actions.fetchDocumentTypeStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchDocumentTypeStatsFailed(error))
  }
}

function* fetchPaymentStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchPaymentStats, payload)
    yield put(actions.fetchPaymentStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchPaymentStatsFailed(error))
  }
}

function* fetchTotalUploadsStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchTotalUploadsStats, payload)
    yield put(actions.fetchTotalUploadsStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchTotalUploadsStatsFailed(error))
  }
}

function* fetchNewInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchNewInvoicesStats, payload)
    yield put(actions.fetchNewInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchNewInvoicesStatsFailed(error))
  }
}

function* fetchPendingInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchPendingInvoicesStats, payload)
    yield put(actions.fetchPendingInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchPendingInvoicesStatsFailed(error))
  }
}

function* fetchDiscountInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchDiscountInvoicesStats, payload)
    yield put(actions.fetchDiscountInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchDiscountInvoicesStatsFailed(error))
  }
}

function* fetchPastDueInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchPastDueInvoicesStats, payload)
    yield put(actions.fetchPastDueInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchPastDueInvoicesStatsFailed(error))
  }
}

function* fetchExceptionInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchExceptionInvoicesStats, payload)
    yield put(actions.fetchExceptionInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchExceptionInvoicesStatsFailed(error))
  }
}

function* fetchPOInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchPOInvoicesStats, payload)
    yield put(actions.fetchPOInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchPOInvoicesStatsFailed(error))
  }
}

function* fetchVendorsInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchVendorsInvoicesStats, payload)
    yield put(actions.fetchVendorsInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchVendorsInvoicesStatsFailed(error))
  }
}

function* fetchPaymentInvoicesStatsWorker({ payload }) {
  try {
    const { data } = yield call(api.fetchPaymentInvoicesStats, payload)
    yield put(actions.fetchPaymentInvoicesStatsSucceeded(data))
  } catch (error) {
    yield put(actions.fetchPaymentInvoicesStatsFailed(error))
  }
}

export default function* documentStatsSaga() {
  yield debounce(150, types.FETCH_COMPLIANCE_STATS, fetchComplianceStatsWorker)
  yield debounce(150, types.FETCH_DOCUMENT_TYPE_STATS, fetchDocumentTypeStatsWorker)
  yield debounce(150, types.FETCH_PAYMENT_STATS, fetchPaymentStatsWorker)
  yield debounce(150, types.FETCH_TOTAL_UPLOADS_STATS, fetchTotalUploadsStatsWorker)
  yield debounce(150, types.FETCH_INVOICES_STATS, fetchNewInvoicesStatsWorker)
  yield debounce(150, types.FETCH_PENDING_INVOICES_STATS, fetchPendingInvoicesStatsWorker)
  yield debounce(150, types.FETCH_DISCOUNT_INVOICES_STATS, fetchDiscountInvoicesStatsWorker)
  yield debounce(150, types.FETCH_PAST_DUE_INVOICES_STATS, fetchPastDueInvoicesStatsWorker)
  yield debounce(150, types.FETCH_EXCEPTION_INVOICES_STATS, fetchExceptionInvoicesStatsWorker)
  yield debounce(150, types.FETCH_PO_INVOICES_STATS, fetchPOInvoicesStatsWorker)
  yield debounce(150, types.FETCH_VENDORS_INVOICES_STATS, fetchVendorsInvoicesStatsWorker)
  yield debounce(150, types.FETCH_PAYMENTS_INVOICES_STATS, fetchPaymentInvoicesStatsWorker)
}
